import { render, staticRenderFns } from "./HistoryPatientDetail.vue?vue&type=template&id=8f99f394&scoped=true&"
import script from "./HistoryPatientDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryPatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPatientDetail.vue?vue&type=style&index=0&id=8f99f394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f99f394",
  null
  
)

export default component.exports